/*!
 */

;(function ($, window, document, undefined) {

    var pluginName = 'beBlog',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype.init = function () {

        var Plugin = this;

        Plugin.initSummernotes();

        Plugin.setEvents();
    };

    Plugin.prototype.initSummernotes = function () {
        var Plugin = this;
        var customTags = [];
        $.get({
          url: '/custom-wysiwyg-tags',
          async: false,
          success: function(data) { customTags = data.customTags }
        });

            var ParametrosButton = function (context) {

                var ui = $.summernote.ui;

                // create button
                var event = ui.buttonGroup([
                    ui.button({
                        contents: 'Estilos beWanted <i class="note-icon-caret" aria-hidden="true"></i>',
                        tooltip: 'Event Data',
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    ui.dropdown({
                        //Etiquetas estilos propios items
                        items: customTags,
                        callback: function (items) {
                            $(items).find('li a').on('click', function(e){
                                e.preventDefault();
                                context.invoke("editor.insertText", '<'+$(this).html()+'>'+Plugin.getSelected()+'</'+$(this).html()+'>')
                            })
                        }
                    })
                ]);

                return event.render();   // return button as jquery object
            };

            Plugin.$element.find('.summernote-complete').summernote({
                height: 150,
                focus: true,
                toolbar: [
                    ['myotherbutton', ['parametros']],
                    ['style', ['style']],
                    ['font', ['bold', 'italic', 'underline', 'clear']],
                    ['fontname', ['fontname']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'hr', 'codeview']]
                ],
                buttons: {
                    parametros: ParametrosButton,
                },
                hint: {
                    match: /#(\w{2,})$/,
                    search: function (keyword, callback) {
                        $.ajax({
                            type: 'POST',
                            dataType: 'json',
                            url: 'some_url'
                        }).then(function (data) {
                            callback(data.items);
                        });
                    },
                    content: function (item) {
                        return '{*' + item.slug + '*} ';
                        //return $('<b>{'+item.slug+'}</b> ').append(" ")[0];
                    },
                    template: function (item) {
                        return '[<strong>' + item.slug + '</strong>] ' + item.name;
                    }
                }
            });
        $('.note-style, .note-fontname, .note-para, .note-color').remove();
        };

        Plugin.prototype.getSelected = function(){
            var t = '';
            //selecciona texto seleccionado dentro del summernote
            if($(window.getSelection().baseNode).closest('.note-editable').length > 0) {
                t = window.getSelection();
            }
            return t;
        };

        Plugin.prototype.setEvents = function () {
            var Plugin = this;

            Plugin.$element.find('.js-beBlog__submit-category').on('click', function () {
                Plugin.sendFormCategory();

            });

            Plugin.$element.find('.js-beForm').on('bw.Success', function (e) {
                var element = $(e.target);
                setTimeout(function () {
                    if (element.hasClass('refresh-form')) {
                        window.location.reload(true)
                    }
                }, 1000)
            });

            Plugin.$element.find('.js-master--blog-categories').on('change', function () {
                $('.select_slug_categories').html('<option value=""></option>');
                $(this).find('option:selected').clone().appendTo('.select_slug_categories')
            });

            Plugin.$element.find('.select_slug_categories').on('change', function () {
                Plugin.selectSlugCategoriesActions($(this));
                Plugin.setSlugInput()
            });

            Plugin.$element.find("#slug-generator").on('keyup', function () {
                Plugin.principalSlugInputActions($(this));
                Plugin.setSlugInput()
            });
            
            $('.js-beBlog__form_categories').on('bw.Success', function () {
                $('#name').val('');
                $('#priority').prop('checked', false);
                setTimeout(function () {
                    $('.o-form__msg').html('');
                }, 2000)
            })

            var featuredTitleColor = $('#featured_title_color');
            var featuredModule = $('#featured_module_id');
            var featuredImg = $('#featured_img');

            $('#featured').on('change', function () {
                featuredImg.closest('.form-group').toggleClass('hide');
                featuredModule.closest('.form-group').toggleClass('hide');
                featuredTitleColor.closest('.form-group').toggleClass('hide');
            })

            featuredTitleColor.val(featuredTitleColor.data('selected')).trigger('change.select2');
        };

        Plugin.prototype.setSlugInput = function () {
            var Plugin = this;
            Plugin.$element.find("input[name=slug]").parent().addClass('is-active');
            Plugin.$element.find("input[name=slug]").val($('.complete-slug').text().substring(1));
        }


        Plugin.prototype.selectSlugCategoriesActions = function (element) {
            var Plugin = this;
            $('.js-category').html('');
            var idSelected = element.val();
            if (idSelected != '' && idSelected != null && idSelected != 'undefined') {
                var categorySlug = '/' + getCleanedString(element.find('option:selected')[0].text.replace(/ /g, "-").toLowerCase());
                $('.js-category').html(categorySlug);
            } else {
                Plugin.cleartextSlug();
            }
        };

        Plugin.prototype.slugLevelTwoInputActions = function (element) {
            if (element.val() != '') {
                $('.js-text-slug').html('/' + element.val().replace(/ /g, "-").toLowerCase());
            } else {
                $('.js-text-slug').html('');
            }
        };


        Plugin.prototype.principalSlugInputActions = function (element) {
            var Plugin = this;
            if (element.val() != '') {
                Plugin.showAddLevelsSlug();
                var slug = '/' + getCleanedString(element.val().replace(/ /g, "-").toLowerCase());
                $('.js-slug').html(slug);
            } else {
                Plugin.hideAddLevelsSlug();
                Plugin.clearSlug();
                Plugin.cleartextSlug();
                Plugin.clearCategorySlug();
            }
        };


        Plugin.prototype.clearSlug = function () {
            $('.js-slug').html('');
        };

        Plugin.prototype.showAddLevelsSlug = function () {
            $('.container_add_level_slug').slideDown();
        };

        Plugin.prototype.hideAddLevelsSlug = function () {
            $('.container_add_level_slug').slideUp();
        };


        Plugin.prototype.clearCategorySlug = function () {
            $('.select_slug_categories').select2('val', '');
        };

        Plugin.prototype.sendFormCategory = function () {
            var Plugin = this;

            var category = Plugin.$element.find('[name:new_category]').val();

            $.ajax({
                url: window.location.origin + '/modules/get/' + $id,
                type: 'POST',
                data: {'category': category},
                success: function (data) {
                    Plugin.printModuleForm(data);
                },
                error: function (data) {
                    console.info(data);
                },
            });

        };


        // A really lightweight plugin wrapper around the constructor,
        // preventing against multiple instantiations
        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Plugin(this, options));
                }
            });
        }

    }
    )(jQuery, window, document);